import {CommonObject} from './common-object';

export class Tool extends CommonObject {
  title: string;
  description: string;
  buttonTitle: string;
  link: string;
  buttonType: 'PRIMARY' | 'SECONDARY' = 'PRIMARY';
  type: 'MAIN' | 'TOOL' = 'TOOL';
}
